
const GetMenuElements = () => [
  /*{
    name: 'Home',
    icon: 'fa fa-home',
    path: '/',
  }, */
  {
    name: 'Autogestión',
    icon: 'fa fa-user',
    subItems: [
      {
        name: 'Parqueadero',
        icon: 'fas fa-parking',
        path: '/parqueadero',
      },
      /*{
        name: 'Mercado',
        icon: 'fas fa-carrot',
        path: '/mercado',
      },*/
      {
        name: 'Descuentos',
        icon: 'fas fa-warehouse',
        path: '/descuentos',
      },
      {
        name: 'Reservas gym',
        icon: 'fas fa-dumbbell',
        path: '/gym',
      },
      {
        name: 'Autogestión',
        icon: 'fa fa-address-card',
        path: '/automanagement'
      }
    ]
  },
  {
    name: 'Restaurante',
    icon: 'fas fa-utensils',
    path: '/restaurante',
  },
  {
    name: 'Beneficios',
    icon: 'fas fa-hand-holding-heart',
    path: '/beneficios',
  },
  {
    name: 'Cumpleaños',
    icon: 'fas fa-birthday-cake',
    path: '/cumpleanos',
  },
  /*{
    name: 'Indicadores Comunidad',
    icon: 'fa fa-heartbeat',
    path: '/tachometer',
  },*/
  {
    name: 'QR',
    icon: 'fa fa-qrcode',
    path: '/qr',
  },
  {
    name: 'logout',
    icon: 'fas fa-sign-out-alt',
    path: '/logout',
  }
];

export default GetMenuElements;